import { WidgetSpec, type WidgetType } from './widgets';
import { FIGURE_ENTRIES } from './catalog/entries-figures';
import { PROSE_ENTRIES } from './catalog/entries-prose';
import { READING_ENTRIES } from './catalog/entries-readings';
import type { WidgetCatalogEntry } from './catalog/entry';

export {
  defineWidgetEntry,
  type AnyWidgetEntry,
  type Normalized,
  type WidgetCatalogEntry,
  type WidgetCategory,
  type WidgetRead,
  type WidgetSpecOf,
} from './catalog/entry';

/**
 * The whole widget vocabulary, keyed by type.
 *
 * THE RUNG: the mapped type below means a variant added to the `WidgetSpec` union without an entry
 * here is a COMPILE error, and an entry whose `type` disagrees with its key is one too (in its
 * `catalog/entries-*.ts` file, through `WidgetCatalogSlice`). There is no comment asking anyone to keep this in sync because there does not need to be.
 */
export const WIDGET_CATALOG: { readonly [T in WidgetType]: WidgetCatalogEntry<T> } = {
  ...FIGURE_ENTRIES,
  ...PROSE_ENTRIES,
  ...READING_ENTRIES,
};

/**
 * The discriminator values, DERIVED from the union.
 *
 * THE FAILURE THIS PREVENTS: a hand-written list drifted from the union and told the model that
 * `choices` — the widget the prompt tells it to prefer — did not exist. It believed the list.
 */
export const WIDGET_TYPES: readonly WidgetType[] = WidgetSpec.options.map(
  (o) => o.shape.type.value,
);
